import { jsxs, jsx } from "react/jsx-runtime";
import { Editable } from "slate-react";
const EditableCanvas = ({ leading, trailing, className, ...editableProps }) => {
  return /* @__PURE__ */ jsxs("div", { className, children: [
    leading,
    /* @__PURE__ */ jsx(Editable, { ...editableProps }),
    trailing
  ] });
};
export {
  EditableCanvas
};
//# sourceMappingURL=EditableCanvas.js.map
